<template>
  <div class="p-3">
   
    <div class="sub-title">{{ $t('roomSize') }}</div>

    <div class="row mt-3">
      <div 
        class="col-3 text-over"         
        @mouseenter="emitContextualHelpChanged('unit')"
        @mouseleave="emitContextualHelpChanged(-1)">
        {{ $t("unit") }}
      </div>

      <div class="col-9">
        <TrinnovInput
          buttonType="select"
          id="unit"
          :modelValue="unit"
          :selectOptions="unitList"
          :event="true"
          @TrinnovInputChanged="emitUnitChanged"
        ></TrinnovInput>
      </div>
    </div>

    <div class="row mt-3">
      <div 
        class="col-3 text-over" 
        @mouseenter="emitContextualHelpChanged('width')"
        @mouseleave="emitContextualHelpChanged(-1)"
      >{{ $t('width') }}</div>
      <div class="col-9">
        <TrinnovInput
          buttonType="numberIncrement"
          id="currentWidth"
          :modelValue="renderCurrentWidth"
          :min="renderMinWidth"
          :max="renderMaxWidth"
          :suffixName="unit === 'feet' ? ' (ft)': ' (cm)'"
          :incrementValue="unit === 'feet' ? 0.1 : 1"
          :longPress="true"
          :event="true"
          @TrinnovInputChanged="emitRoomSizeChanged"
        ></TrinnovInput>
      </div>
    </div>

    <div class="row mt-3 text-over">
      <div 
        class="col-3" 
        @mouseenter="emitContextualHelpChanged('height')"
        @mouseleave="emitContextualHelpChanged(-1)"
      >{{ $t('height') }}</div>
      <div class="col-9">
        <TrinnovInput
          buttonType="numberIncrement"
          id="currentHeight"
          :modelValue="renderCurrentHeight"
          :min="renderMinHeight"
          :max="renderMaxHeight"
          :suffixName="unit === 'feet' ? ' (ft)': ' (cm)'"
          :incrementValue="unit === 'feet' ? 0.1 : 1"
          :longPress="true"
          :event="true"
          @TrinnovInputChanged="emitRoomSizeChanged"
        ></TrinnovInput>
      </div>
    </div>


  </div>
</template>

<script>
import TrinnovInput from "@/lib/tui/components/buttons/TrinnovInput.vue";
export default {
  name: "CRoomSize",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    TrinnovInput
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    minHeight: Number,
    maxHeight: Number,
    minWidth: Number,
    maxWidth: Number,
    currentWidth: Number,
    currentHeight: Number,
    withScales: Boolean,
    unit: String
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      unitList: [
        { id: "cm", label: this.$t("cm") },
        { id: "feet", label: this.$t("feet") },
      ],
      feetConst: 0.0328084
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    emitRoomSizeChanged: function(event) {
      let value = this.unit === "cm" ? event.value : parseFloat(event.value / this.feetConst).toFixed(1);
      this.$emit("RoomSizeChanged", { id: event.id, value });
    },
    //////////////////////////////////////////////////////////////////
    emitWithScalesChanged: function(event) {
      this.$emit("WithScalesChanged", event);
    },
    //////////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit('ContextualHelpChanged', event);
    },
    //////////////////////////////////////////////////////////////////
    emitUnitChanged: function(event) {
      this.$emit("UnitChanged", event.value);
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  computed: {
    renderCurrentWidth: function() {
      if (!this.unit || !this.currentWidth) return;

      if (this.unit === "feet")
        return parseFloat((this.currentWidth * this.feetConst).toFixed(1));

      return this.currentWidth;
    },
    //////////////////////////////////////////////////////////////////
    renderCurrentHeight: function() {
      if (!this.unit || !this.currentHeight) return;

      if (this.unit === "feet")
        return parseFloat((this.currentHeight * this.feetConst).toFixed(1));

      return this.currentHeight;
    },
    //////////////////////////////////////////////////////////////////
    renderMinWidth: function() {
      if (!this.unit || !this.minWidth) return;

      if (this.unit === "feet")
        return parseFloat((this.minWidth * this.feetConst).toFixed(1));

      return this.minWidth;
    },
    //////////////////////////////////////////////////////////////////
    renderMaxWidth: function() {
      if (!this.unit || !this.maxWidth) return;

      if (this.unit === "feet")
        return parseFloat((this.maxWidth * this.feetConst).toFixed(1));

      return this.maxWidth;
    },
    //////////////////////////////////////////////////////////////////
    renderMinHeight: function() {
      if (!this.unit || !this.minHeight) return;

      if (this.unit === "feet")
        return parseFloat((this.minHeight * this.feetConst).toFixed(1));

      return this.minHeight;
    },
    //////////////////////////////////////////////////////////////////
    renderMaxHeight: function() {
      if (!this.unit || !this.maxHeight) return;

      if (this.unit === "feet")
        return parseFloat((this.maxHeight * this.feetConst).toFixed(1));

      return this.maxHeight;
    }

  }
}
</script>

<style lang="scss" scoped>
  .text-over {
    color: $white;
    &:hover {
      color: $active;
    }
  }
</style>